/*
* Created on Jan 13, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import {useNavigate as useReactRouterDomNavigator} from "react-router-dom";
import {useOrganization} from "../context/OrganizationContext";
import {useRegion} from "../context/RegionContext";
import {useGlobalConfigContext} from "../context/GlobalConfigContext";
import axios from "axios";
import qs from "qs";

export const useNavigate = (organization) => {
    const history = useReactRouterDomNavigator();
    const {url} = useRegion();
    // const updateOrg = useOrganizationUpdate();
    const {setCurrentOrg} = useOrganization();
    const oid = organization ? organization.organization_id : '';
    const {useCurrentLang} = useGlobalConfigContext();
    const lang = useCurrentLang();

    const goHome = (event, org_id=oid) => {
        setCurrentOrg(null);
        history(`/`);
    }

    const goAccountList = (event, org_id=oid) => {
        setCurrentOrg(organization);
        history(`/${org_id}/account-list`)
    }

    const goGroups = (event, group_id, org_id=oid) => {
        setCurrentOrg(organization);
        history(`/${org_id}/group`)
    }

    const goSites = (event, site_id, org_id=oid) => {
        setCurrentOrg(organization);
        history(`/${org_id}/sites`)
    }

    const goDevice = (event, org_id=oid) => {
        setCurrentOrg(organization);
        history(`/${org_id}/devices`)
    }

    const goSettings = (event, org_id=oid) => {
        setCurrentOrg(organization);
        history(`/${org_id}/settings`)
    }

    const goAccSignInPage = (event) => {
        // const state = {
        //     client_id: REACT_APP_OAUTH_CLINET_ID,
        //     response_type: 'code',
        //     redirect_uri: `${REACT_APP_ORGANIZATION_CENTER_DOMAIN}/oauth/receive_auth`,
        //     state: 'something'
        // }
        let state = undefined;
        if (window.location.pathname.startsWith('/delete-org-confirm')) {
            state = window.location.pathname
        }
        const params = {
            state
        }
        // const url = `${REACT_APP_ACC_URL}/signin?${qs.stringify(params)}`
        const url = `/doSignin?${qs.stringify(params)}`
        axios.get(url).then(resp=>{
            window.location.href = resp.data.result.url
        });
        // const goUrl = `${url.get_org_center_domain()}/doSignIn`
        // window.location = goUrl
    }

    const goAccSignUpPage = (event) => {
        const receive_auth = `${window._env_.REACT_APP_ORGANIZATION_CENTER_DOMAIN}/oauth/receive_auth`;
        const goUrl = `${url.get_acc_url()}/signup?app_id=${window._env_.REACT_APP_OAUTH_CLINET_ID}&lang=${lang}&redirect_uri=${receive_auth}`
        window.location = goUrl
        //https://dev-account.qnap.com/signup?app_id=609a210e1375647f87489516&lang=en&redirect_uri=https%3A%2F%2Fwww.dev.myqnapcloud.com%2Freceive_auth&state=%2Fu
    }

    return { goAccountList, goGroups, goSites, goAccSignInPage, goDevice, goHome, goAccSignUpPage, goSettings}
}
